import React, { useContext } from 'react';
import { Auth } from 'aws-amplify';

import { AuthenticatorContext } from './AuthenticatorContext';
import {
   AuthenticatorForm,
   AuthenticatorInput,
   AuthenticatorSubmitButton,
} from './AuthenticatorForm';

const SetNewPassword = () => {
   const {
      state: { userData },
   } = useContext(AuthenticatorContext);

   const formName = userData.needsName
      ? 'Complete Profile'
      : 'Set New Password';

   return (
      <AuthenticatorForm
         heading={formName}
         onSubmit={(formData) => {
            const attributes = userData.needsName
               ? {
                    name: formData.get('name'),
                 }
               : undefined;

            return Auth.completeNewPassword(
               userData.userObject,
               formData.get('password'),
               attributes
            );
         }}
      >
         {userData.needsName && (
            <AuthenticatorInput
               name="name"
               autoComplete="given-name"
               placeholder="First Name"
               required
               autoFocus
            />
         )}
         <AuthenticatorInput
            name="password"
            type="password"
            autoComplete="new-password"
            placeholder="New Password"
            required
            minLength="8"
            autoFocus={!userData.needsName}
         />
         <AuthenticatorSubmitButton>{formName}</AuthenticatorSubmitButton>
      </AuthenticatorForm>
   );
};

export { SetNewPassword };
